module.exports = __webpack_public_path__ + "static/media/wordcollection.eac55b47.png";